var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c(_vm.agentTypes[_vm.level].icon,{tag:"component",staticClass:"agent-icon",class:{ 'agent-icon--small': _vm.small, 'agent-icon--large': _vm.large }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }